<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
          <BaseInput
              v-model="filters.name"
              :placeholder="$t('Name')"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12" v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.client_name')"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits([ 'search' ]);

const { filters }    = toRefs(props);
const clientDropdown = toRefs(props)[ 'clientDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
